import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { EezycoinOffering } from "src/apis/eezycoin";
import NoDataAlert from "src/pages/components/NoDataAlert";
import TableActionsCell from "src/pages/components/TableActionsCell";
import { isUserAdministrator } from "src/utils/auth";
import { formatCents } from "src/utils/currency";

type EezycoinOfferingTableProps = {
  offerings: EezycoinOffering[];
};

export default function EezycoinOfferingTable({offerings}: EezycoinOfferingTableProps) {
  const hasOfferings = useMemo(
    () => Boolean(offerings) && offerings.length > 0,
    [offerings]
  );
  const isAdmin = useMemo(
    isUserAdministrator,
    []
  )

  return hasOfferings ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Oferta</strong></TableCell>
            <TableCell><strong>Ativo?</strong></TableCell>
            <TableCell><strong>Bundle?</strong></TableCell>
            <TableCell><strong>Eezyfamily?</strong></TableCell>
            <TableCell><strong>Coins inclusas</strong></TableCell>
            <TableCell><strong>Valor por coin</strong></TableCell>
            <TableCell><strong>Valor total</strong></TableCell>
            {isAdmin && (
              <TableCell><strong>Ações</strong></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {offerings?.map((offering: EezycoinOffering) => (
            <TableRow>
              <TableCell>{offering?.id}</TableCell>
              <TableCell>{offering?.title}</TableCell>
              <TableCell><Checkbox checked={offering?.is_active} /></TableCell>
              <TableCell><Checkbox checked={offering?.is_bundle} /></TableCell>
              <TableCell><Checkbox checked={offering?.is_eezyfamily_offer} /></TableCell>
              <TableCell>{offering?.coins_included}</TableCell>
              <TableCell>{formatCents(offering?.value_per_coin_cents)}</TableCell>
              <TableCell>{formatCents(offering?.total_value_cents)}</TableCell>
              {isAdmin && (
                <TableActionsCell editUrl={`/eezycoin/ofertas/${offering?.id}/editar`}/>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  );
};
